module.exports = __webpack_public_path__ + "static/media/down-arrow.042107bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/organisms/ProfileDropdown/down-arrow.svg
// module id = 586
// module chunks = 0